import { useReducer } from 'react'
import type { ResetPasswordFlowAction, ResetPasswordFlowState } from './ResetPasswordFlow.types'

const initialState: ResetPasswordFlowState = {
  token: '',
  pageState: 'loading',
  password: '',
  confirmPassword: '',
  passwordTouched: false,
  confirmPasswordTouched: false,
  passwordDirty: false,
  confirmPasswordDirty: false,
  formSubmitted: false,
  submitting: false,
  success: false,
  formError: '',
}

const resetPasswordFlowReducer = (
  state: ResetPasswordFlowState,
  action: ResetPasswordFlowAction,
): ResetPasswordFlowState => {
  switch (action.type) {
    case 'INIT_FROM_QUERY': {
      return {
        ...state,
        token: action.token,
        pageState: action.token ? 'loading' : 'invalid',
      }
    }
    case 'TOKEN_VALIDATION_RESOLVED': {
      return {
        ...state,
        pageState: action.status,
      }
    }
    case 'TOKEN_VALIDATION_FAILED': {
      return {
        ...state,
        pageState: 'invalid',
      }
    }
    case 'SET_PASSWORD': {
      return {
        ...state,
        password: action.value,
        passwordDirty: true,
        formError: state.formError ? '' : state.formError,
      }
    }
    case 'SET_CONFIRM_PASSWORD': {
      return {
        ...state,
        confirmPassword: action.value,
        confirmPasswordDirty: true,
        formError: state.formError ? '' : state.formError,
      }
    }
    case 'SET_PASSWORD_TOUCHED': {
      return {
        ...state,
        passwordTouched: action.value,
      }
    }
    case 'SET_CONFIRM_PASSWORD_TOUCHED': {
      return {
        ...state,
        confirmPasswordTouched: action.value,
      }
    }
    case 'SET_FORM_SUBMITTED': {
      return {
        ...state,
        formSubmitted: action.value,
      }
    }
    case 'SET_SUBMITTING': {
      return {
        ...state,
        submitting: action.value,
      }
    }
    case 'SET_SUCCESS': {
      return {
        ...state,
        success: action.value,
      }
    }
    case 'SET_FORM_ERROR': {
      return {
        ...state,
        formError: action.value,
      }
    }
    case 'SET_PAGE_STATE': {
      return {
        ...state,
        pageState: action.value,
      }
    }
    default:
      return state
  }
}

export const useResetPasswordFlowReducer = () => useReducer(resetPasswordFlowReducer, initialState)
